/**
 * Creating and exporting app context here
 */
import { createContext } from "react";
export const AppContext = createContext();
